import React, { PureComponent } from 'react';
import { inject } from 'mobx-react';
import { string, func, object } from 'prop-types';
import { Check } from 'wix-ui-icons-common';

import styles from './copy.scss';

import { TextButton, Text } from 'wix-style-react';

class Copy extends PureComponent {
  static propTypes = {
    toCopy: string.isRequired,
    buttonText: string.isRequired,
    afterClickText: string.isRequired,
    dataHook: string,
    onCopy: func,
    biLogger: object,
  };

  state = {
    copied: false,
  };

  _copiedTimeout = 0;

  componentWillUnmount() {
    clearTimeout(this._copiedTimeout);
  }

  copy = (text) => {
    let textarea = document.createElement('textarea');
    textarea.style.position = 'absolute';
    textarea.style.top =
      (window.pageYOffset || document.documentElement.scrollTop) + 'px';
    textarea.style.left = '-9999px';
    textarea.value = text || '';
    document.body.appendChild(textarea);
    try {
      textarea.select();
      document.execCommand('copy');
      return true;
    } catch (err) {
      return false;
    } finally {
      document.body.removeChild(textarea);
      textarea = null;
    }
  };

  handleCopy = (e) => {
    e.preventDefault();
    this.props.biLogger.integrationFbCopyLinkClick();
    this.copy(this.props.toCopy);
    this.setState({ copied: true });
    clearTimeout(this._copiedTimeout);
    this._copiedTimeout = setTimeout(
      () => this.setState({ copied: false }),
      2500,
    );
    this.props.onCopy && this.props.onCopy();
  };

  renderCopyButton = () => (
    <TextButton onClick={this.handleCopy} dataHook={this.props.dataHook}>
      {this.props.buttonText}
    </TextButton>
  );

  renderCopiedText = () => (
    <span className={styles.copied}>
      <span className={styles['v-icon']}>
        <Check size="24px" />
      </span>
      <Text skin="success">{this.props.afterClickText}</Text>
    </span>
  );

  render() {
    return this.state.copied
      ? this.renderCopiedText()
      : this.renderCopyButton();
  }
}

export default inject('biLogger')(Copy);
